// Helper to check if we're in Electron
export const isElectron = (): boolean => {
  // console.log('🔍 Checking if running in Electron...');
  // console.log('🔍 window object:', typeof window !== 'undefined' ? 'exists' : 'undefined');
  // console.log('🔍 window.electron:', window?.electron);
  
  // Check for Electron-specific objects
  const hasElectronObject = typeof window !== 'undefined' && window.electron !== undefined;
  
  // console.log('🔍 Detection results:', {
  //   hasElectronObject,
  //   electronObject: window.electron,
  //   electronKeys: window.electron ? Object.keys(window.electron) : [],
  //   electronAuth: window.electron?.auth,
  //   electronSystem: window.electron?.system
  // });
  
  return hasElectronObject;
};

// Helper to get the Electron API
export const getElectronAPI = () => {
  // console.log('🔍 Getting Electron API...');
  if (!isElectron()) {
    // console.warn('🔍 Not running in Electron - window.electron:', window.electron);
    return null;
  }
  
  const api = window.electron;
  // console.log('🔍 Electron API details:', {
  //   api,
  //   authMethods: api?.auth ? Object.keys(api.auth) : [],
  //   systemMethods: api?.system ? Object.keys(api.system) : [],
  //   isElectronFlag: api?.isElectron
  // });
  return api;
};

// Helper to check if a specific API is available
export const hasElectronAPI = (apiPath: string): boolean => {
  // console.log(`🔍 Checking for API: ${apiPath}`);
  if (!isElectron()) {
    console.warn(`🔍 Not running in Electron while checking for ${apiPath}`);
    return false;
  }

  const api = getElectronAPI();
  if (!api) {
    // console.warn(`🔍 No Electron API available while checking for ${apiPath}`);
    return false;
  }

  const parts = apiPath.split('.');
  let current: any = api;

  for (const part of parts) {
    if (!current || typeof current[part] === 'undefined') {
      // console.warn(`🔍 API path ${apiPath} not found at ${part}. Current object:`, current);
      return false;
    }
    current = current[part];
  }

  // console.log(`🔍 API ${apiPath} is available:`, {
  //   type: typeof current,
  //   value: current
  // });
  return true;
}; 